import {
  useCallback,
  useMemo,
  useState,
} from 'react';
import { getDocumentFields } from 'utils/helper';

export default ({
  section,
  data,
  type,
}) => {
  const [activeAccordion, setAccordion] = useState(0);
  const [activeCard, setCard] = useState(0);

  const {
    title,
    description,
    contentModules,
    view,
  } = getDocumentFields(
    section,
    [
      'title',
      'description',
      'contentModules',
      'view',
    ],
  );

  const handleAccordionClick = useCallback((id) => {
    setAccordion(id);
    setCard(0);
  }, []);

  const accordionList = useMemo(() => (contentModules || [])
    .map((item, id) => getDocumentFields(item, [
      'title',
      'text',
    ])), [contentModules]);

  const activeImage = useMemo(() => {
    const { images } = getDocumentFields(
      contentModules[activeAccordion],
      ['images'],
    );

    return images[0];
  }, [activeAccordion, contentModules]);

  return {
    type,
    view,
    title,
    description,
    activeImage,
    accordionList,
    activeAccordion,
    handleAccordionClick,
  };
};
